import { createSlice } from '@reduxjs/toolkit';
import fetchUsers, { updateUser, removeUser } from './action';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    users: [],
    isLoading: true,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, { payload }) => {
        state.users = payload;
        state.isLoading = false;
      })
      .addCase(fetchUsers.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload;
      })
      .addCase(updateUser.fulfilled, (state, { payload }) => {
        const findUser = state.users.find(
          (user) => user._id === payload.user_id
        );
        Object.assign(findUser, payload);
      })
      .addCase(removeUser.fulfilled, (state, { payload }) => {
        state.users = state.users.filter((user) => user._id !== payload._id);
      });
  },
});

export default userSlice.reducer;
